export default __webpack_public_path__ + "static/media/1_census.4c5bfa46.csv";